import { useState, useEffect } from "react";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import { Card, Col, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import {
    decryptFromStoreLoc,
    encryptAndStoreLoc,
} from "../../helper/localStore";
import { toast } from "react-toastify";
import api from "../../helper/api";
import { getImageBaseUrl, getServerURL } from "../../helper/envConfig";
import { useTranslation } from "react-i18next";
import "../../i18n"; // important to import

function AIUserPlans() {
    const { t } = useTranslation("AIUserPlans");
    const navigate = useNavigate();
    const serverURL = getServerURL();
    const imageUrl = getImageBaseUrl();
    const [user, setUser] = useState({});
    const [trailsData, setTrailsData] = useState([]);

    const pricingPlans = [
        {
            title: t("free_plan_title"),
            planType: "free",
            amount: 0,
            price: "€0",
            descriptions: [
                t("free_plan_feature_1"),
                t("free_plan_feature_2"),
                t("free_plan_feature_3"),
                t("free_plan_feature_4"),
            ],
            variant: "primary",
            priceDescription: t("free_plan_per"),
            cardClass: "starter",
            textWhite: false,
        },
        {
            title: t("full_access_plan_title"),
            price: "€3",
            planType: "full-access",
            amount: 3,
            descriptions: [
                t("full_access_plan_feature_1"),
                t("full_access_plan_feature_2"),
                t("full_access_plan_feature_3"),
                t("full_access_plan_feature_4"),
                t("full_access_plan_feature_5"),
            ],
            variant: "warning",
            priceDescription: t("full_access_plan_per"),
            cardClass: "business",
            textWhite: true,
        },
        {
            title: t("enterprise_plan_title"),
            price: t("enterprise_plan_price"),
            amount: 0,
            planType: "enterprise",
            descriptions: [
                t("enterprise_plan_feature_1"),
                t("enterprise_plan_feature_2"),
                t("enterprise_plan_feature_3"),
                t("enterprise_plan_feature_4"),
                t("enterprise_plan_feature_5"),
            ],
            variant: "warning",
            priceDescription: t("enterprise_plan_per"),
            cardClass: "enterprise",
            textWhite: true,
        },
    ];

    const getTrails = async () => {
        try {
            var response = await api.get(`${serverURL}courses/course-trails/`);
            if (response.data.success) {
                setTrailsData(response.data.data);
            } else {
                // console.error("Error:", response.data.message);
            }
        } catch (error) {
            // console.error("Error:", error);
        }
    };

    useEffect(() => {
        getTrails();
    }, []);

    useEffect(() => {
        const decryptedInfoResult = decryptFromStoreLoc("user");
        setUser(decryptedInfoResult);
    }, []);

    const handlePayment = async (type, amount) => {
        try {
            if (type === "enterprise") {
                toast.error("Please contact us for enterprise plans.");
                return;
            }

            if (type === "free") {
                const response = await api.postWithToken(
                    `${serverURL}payments/is-free-plan-used/`,
                    {}
                );
                if (response.data.is_free_plan_used) {
                    toast.error(response.data.message);
                    return;
                }
            }

            const obj = {
                plan_type: type,
                amount: amount,
                description: "Ready for payment",
                duration_type: "month",
            };
            const response = await api.postWithToken(
                `${serverURL}payments/payment/`,
                obj
            );
            if (response.data.success) {
                if (response.data.payment_url) {
                    window.location.href = response.data.payment_url;
                } else {
                    const paymentData = { status: true };
                    encryptAndStoreLoc("paymentData", paymentData);
                    toast.success(response.data.message);
                    setTimeout(() => {
                        if (user?.role === 12) {
                            navigate("/business-home", { replace: true });
                            window.location.reload();
                        } else if (user?.role === 2) {
                            navigate("/customer-home", { replace: true });
                            window.location.reload();
                        }
                    }, 1000);
                }
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            toast.error(error?.response?.data?.message);
        }
    };

    return (
        <>
            <Header />
            <section className="payment-flow-section new-payment-flow-section">
                <div className="container">
                    <h3 className="welcome-title max-width-100">
                        {t("chooseyoursubscriptionplan")}
                    </h3>
                    {user?.role === 12 && (
                        <p className="welcome-description plan-description">
                            {t("plandes")}
                        </p>
                    )}
                    {user?.role === 2 && (
                        <p className="welcome-description plan-description">
                            {t("plandes2")}
                        </p>
                    )}
                    <Row className="mb-0 mt-md-4">
                        {pricingPlans.map((plan, index) => (
                            <Col
                                className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-12 mb-4"
                                key={index}
                            >
                                <Card
                                    className={`pricing-card ${plan.cardClass}`}
                                >
                                    <Card.Body
                                        className={`text-center px-4 py-4 py-md-5 ${
                                            plan.textWhite ? "text-white" : ""
                                        }`}
                                    >
                                        <h3 className="plan-title">
                                            {plan.title}
                                        </h3>
                                        {Array.isArray(plan.descriptions) &&
                                            plan.descriptions.map((desc, i) => {
                                                if (
                                                    user?.role === 2 &&
                                                    plan.planType === "free" &&
                                                    i === 3
                                                ) {
                                                    return null;
                                                } else {
                                                    return (
                                                        <div
                                                            className="d-flex align-items-start gap-2 mt-2"
                                                            key={i}
                                                        >
                                                            {user?.role ===
                                                                12 &&
                                                                plan.planType ===
                                                                    "free" &&
                                                                i === 3}
                                                            <img
                                                                src={
                                                                    plan.textWhite
                                                                        ? "/png/check-arrow-white.png"
                                                                        : "/png/check-arrow.png"
                                                                }
                                                                width={24}
                                                                height={24}
                                                                alt=""
                                                            />
                                                            <p className="plan-description mb-0">
                                                                {desc}
                                                            </p>
                                                        </div>
                                                    );
                                                }
                                            })}
                                    </Card.Body>
                                    <Card.Footer className="bg-transparent border-0 justify-content-center d-flex pb-5">
                                        <div>
                                            <div
                                                className={`plan-price text-center  ${
                                                    plan.textWhite
                                                        ? "text-white"
                                                        : ""
                                                }`}
                                            >
                                                {plan.price}
                                            </div>
                                            <p
                                                className={`plan-description mb-0 text-center ${
                                                    plan.textWhite
                                                        ? "text-white"
                                                        : ""
                                                }`}
                                            >
                                                {plan.priceDescription}
                                            </p>
                                            <button
                                                className="mt-5 d-flex m-auto"
                                                onClick={() =>
                                                    handlePayment(
                                                        plan.planType,
                                                        plan.amount
                                                    )
                                                }
                                            >
                                                {t("plan_cta")}
                                            </button>
                                        </div>
                                    </Card.Footer>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                    <div className="available-trails pb-md-5">
                        <h3 className="welcome-title max-width-100">
                            {t("availabletrails")}
                        </h3>
                        <p className="welcome-description plan-description">
                            {t("after_purchasing_subscription")}
                        </p>

                        <Row className="available-trails-cards g-3">
                            {trailsData.map((trail) => (
                                <Col key={trail.id} md={6} lg={6} xl={4}>
                                    <Card>
                                        <Card.Body>
                                            <div className="d-flex align-items-center gap-3">
                                                <img
                                                    width={100}
                                                    height={100}
                                                    src={imageUrl + trail.icon}
                                                    alt={trail.name}
                                                />
                                                <div>
                                                    <h5>{trail.name}</h5>
                                                    <p>{trail.description}</p>
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            ))}
                        </Row>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
}

export default AIUserPlans;
